import { inBiliApp, biliBridge } from "@bilibili/js-bridge";
import { httpGet } from "@bilibili/growup-utils/_esm5/http";

import { detectEnv, ENV } from "./detect";
const env = detectEnv();
export const apiProtocol = env !== ENV.LOCAL ? "https" : "http";

export interface UserInfo {
  isLogin: boolean | undefined;
  mid: number;
  uname: string;
  face: string;
}

export function getLoginInfo(): Promise<UserInfo> {
  if (inBiliApp) {
    return new Promise((resolve) => {
      biliBridge.callNative({
        method: "auth.getUserInfo",
        data: {
          type: "default"
        },
        callback: function(userInfo: any) {
          resolve({
            isLogin: +userInfo.state === 1,
            uname: userInfo.userName,
            ...userInfo
          });
        }
      });
    });
  } else {
    return httpGet(`${apiProtocol}://api.bilibili.com/x/web-interface/nav`, {
      query: {
        jsonp: "jsonp"
      },
      needLogin: false,
      hideError: true
    }).then((res) =>
      +res.code === 0
        ? res.data || {
            isLogin: false,
            mid: 0,
            uname: "",
            face: ""
          }
        : {
            isLogin: false,
            mid: 0,
            uname: "",
            face: ""
          }
    );
  }
}
